import React from 'react';
import { Link } from 'react-router-dom';
import { DynamicIcon } from '../components/icons/DynamicIcon';

const TermsOfUsePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <DynamicIcon name="fileText" size={32} className="text-blue-600 mr-3" />
              <h1 className="text-2xl font-bold text-gray-900">Termos de Uso</h1>
            </div>
            <Link
              to="/"
              className="flex items-center text-gray-600 hover:text-gray-900"
            >
              <DynamicIcon name="arrowLeft" size={16} className="mr-2" />
              Voltar
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg p-6 sm:p-8">
          <div className="mb-8 text-center">
            <p className="text-sm text-gray-500">Última atualização: 29 de junho de 2025</p>
          </div>

          <div className="prose prose-blue max-w-none">
            <h2 className="text-xl font-bold text-gray-900 mb-4">1. DEFINIÇÕES E INTERPRETAÇÃO</h2>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">1.1 Definições</h3>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li><strong>"EventPour"</strong> ou <strong>"Plataforma"</strong>: Software-as-a-Service (SaaS) destinado a bartenders e profissionais de eventos para criação de orçamentos e gestão de serviços;</li>
              <li><strong>"Usuário"</strong>: Pessoa física ou jurídica que utiliza a Plataforma;</li>
              <li><strong>"Serviços"</strong>: Todas as funcionalidades oferecidas pela Plataforma;</li>
              <li><strong>"Conta"</strong>: Perfil criado pelo Usuário para acesso aos Serviços;</li>
              <li><strong>"Conteúdo do Usuário"</strong>: Dados, informações, documentos e materiais inseridos pelo Usuário na Plataforma;</li>
              <li><strong>"Assinatura"</strong>: Plano pago escolhido pelo Usuário para acesso aos Serviços premium.</li>
            </ul>

            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">2. ACEITAÇÃO DOS TERMOS</h2>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">2.1 Concordância</h3>
            <p className="text-gray-700">
              Ao acessar, cadastrar-se ou utilizar a EventPour, o Usuário declara ter lido, compreendido e concordado integralmente com estes Termos de Uso e nossa Política de Privacidade.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">2.2 Capacidade Legal</h3>
            <p className="text-gray-700">
              O Usuário declara ter capacidade legal para contratar e utilizar os Serviços, sendo maior de 18 anos ou devidamente representado por responsável legal.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">2.3 Alterações</h3>
            <p className="text-gray-700">
              A EventPour reserva-se o direito de modificar estes termos a qualquer momento, notificando os Usuários com antecedência mínima de 30 dias.
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">3. DESCRIÇÃO DOS SERVIÇOS</h2>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">3.1 Funcionalidades Principais</h3>
            <p className="text-gray-700">A EventPour oferece:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Criação e gestão de orçamentos para eventos</li>
              <li>Catálogo personalizável de bebidas e serviços</li>
              <li>Cálculos automáticos de custos e margens</li>
              <li>Geração de propostas em PDF personalizadas</li>
              <li>Sistema de templates e modelos</li>
              <li>Dashboard analytics e relatórios</li>
              <li>Integração com WhatsApp e outras ferramentas</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">3.2 Disponibilidade</h3>
            <p className="text-gray-700">
              Embora busquemos manter a Plataforma disponível 24/7, não garantimos ausência total de interrupções, podendo haver manutenções programadas ou emergenciais.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">3.3 Atualizações</h3>
            <p className="text-gray-700">
              A EventPour pode atualizar, modificar ou descontinuar funcionalidades, sempre buscando melhorar a experiência do Usuário.
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">4. CADASTRO E CONTA DO USUÁRIO</h2>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">4.1 Informações de Cadastro</h3>
            <p className="text-gray-700">
              O Usuário compromete-se a fornecer informações verdadeiras, precisas e atualizadas durante o cadastro e a mantê-las atualizadas.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">4.2 Responsabilidade pela Conta</h3>
            <p className="text-gray-700">O Usuário é integralmente responsável por:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Manter a confidencialidade de suas credenciais</li>
              <li>Todas as atividades realizadas em sua Conta</li>
              <li>Notificar imediatamente sobre uso não autorizado</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">4.3 Suspensão e Encerramento</h3>
            <p className="text-gray-700">
              A EventPour pode suspender ou encerrar Contas em caso de violação destes termos, atividades fraudulentas ou uso inadequado da Plataforma.
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">5. PLANOS E PAGAMENTOS</h2>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">5.1 Planos Disponíveis</h3>
            <p className="text-gray-700">
              A EventPour oferece planos gratuitos e pagos, com funcionalidades e limitações específicas descritas na Plataforma.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">5.2 Assinaturas Pagas</h3>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Cobrança mensal ou anual conforme plano escolhido</li>
              <li>Pagamento via cartão de crédito, boleto ou PIX</li>
              <li>Renovação automática, salvo cancelamento</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">5.3 Política de Cancelamento</h3>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Cancelamento a qualquer momento pelo painel do Usuário</li>
              <li>Acesso mantido até o fim do período pago</li>
              <li>Sem reembolso proporcional para cancelamentos</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">5.4 Aumentos de Preço</h3>
            <p className="text-gray-700">
              Aumentos de preço serão comunicados com 30 dias de antecedência, com direito de cancelamento sem ônus.
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">6. USO ADEQUADO DA PLATAFORMA</h2>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">6.1 Usos Permitidos</h3>
            <p className="text-gray-700">O Usuário pode utilizar a Plataforma exclusivamente para:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Criação de orçamentos profissionais para eventos</li>
              <li>Gestão de seu negócio de bartender/eventos</li>
              <li>Comunicação com clientes através das ferramentas disponíveis</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">6.2 Usos Proibidos</h3>
            <p className="text-gray-700">É expressamente vedado:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Utilizar a Plataforma para fins ilegais ou não autorizados</li>
              <li>Compartilhar credenciais de acesso com terceiros</li>
              <li>Realizar engenharia reversa ou tentar acessar código-fonte</li>
              <li>Sobrecarregar sistemas com solicitações excessivas</li>
              <li>Inserir conteúdo ofensivo, difamatório ou ilegal</li>
              <li>Utilizar a Plataforma para spam ou comunicações não solicitadas</li>
              <li>Violar direitos de propriedade intelectual</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">6.3 Monitoramento</h3>
            <p className="text-gray-700">
              A EventPour pode monitorar o uso da Plataforma para garantir conformidade com estes termos.
            </p>

            <p className="text-gray-700">
              Utilizamos cookies e tecnologias similares para melhorar a experiência do Usuário, conforme detalhado em nossa <a href="https://termos-de-uso-eventpour.netlify.app/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">Política de Cookies</a>.
            </p>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-center text-gray-700 font-semibold">
                EventPour Tecnologia Ltda.<br />
                CNPJ: XX.XXX.XXX/0001-XX<br />
                Email: legal@eventpour.com.br
              </p>
              
              <p className="text-center text-gray-600 mt-4 italic">
                Ao utilizar a EventPour, você confirma ter lido e concordado com estes Termos de Uso.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-100 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center mb-4 md:mb-0">
              <DynamicIcon name="glasses" size={24} className="text-blue-600 mr-2" />
              <span className="font-bold text-gray-900">EventPour</span>
            </div>
            
            <div className="flex space-x-6 text-sm">
              <a href="https://politica-de-privacidade-eventpour.netlify.app/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900">Política de Privacidade</a>
              <a href="https://termos-de-uso-eventpour.netlify.app/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900">Política de Cookies</a>
              <span className="text-gray-900 font-medium">Termos de Uso</span>
              <a href="#" className="text-gray-600 hover:text-gray-900">Contato</a>
            </div>
          </div>
          
          <div className="mt-8 text-center text-sm text-gray-500">
            &copy; {new Date().getFullYear()} EventPour. Todos os direitos reservados.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfUsePage;